export default __webpack_public_path__ + "static/media/Setup.c2a30fb8.svg";